import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getPermissions } from '../../auth/login/redux/selectors';
import * as _ from 'lodash';
import {
    getJurisdictionTypeByCode,
    getSelectedBrandId,
    getSelectedJurisdictionCode
} from '../../jurisdiction/redux/selectors';
import { hasPermission } from '../models/permissions';

/**
 * Renders its children only if the user has at least one of `permission`.
 *
 * Permissions are checked in the jurisdiction and brand chosen in the header,
 * unless `scope` ({ jurisdictionCode, brandId }) names another one, such as the
 * jurisdiction and brand of the alert an action applies to.
 *
 * Whether that jurisdiction is a sandbox matters: a mapping to all jurisdictions
 * does not cover one (see hasPermission).
 */
class ShowIfPermission extends Component {
    get allowedPermissions() {
        return _.isArray(this.props.permission)
            ? this.props.permission
            : [this.props.permission];
    }

    showChildComponent = () => {
        const { scope, userPermissions, jurisdictionType } = this.props;
        const { jurisdictionCode, brandId } = scope || this.props;

        return this.allowedPermissions.some(permission =>
            hasPermission(
                userPermissions,
                permission,
                jurisdictionCode,
                brandId,
                jurisdictionType
            )
        );
    };

    render = () => (
        <Fragment>{this.showChildComponent() && this.props.children}</Fragment>
    );
}

const mapStateToProps = (state, { scope }) => {
    const jurisdictionCode = getSelectedJurisdictionCode(state);

    return {
        userPermissions: getPermissions(state),
        jurisdictionCode,
        brandId: getSelectedBrandId(state),
        jurisdictionType: getJurisdictionTypeByCode(
            state,
            scope ? scope.jurisdictionCode : jurisdictionCode
        )
    };
};

export default connect(mapStateToProps, null)(ShowIfPermission);
